module.exports = __webpack_public_path__ + "img/homeTag-icon-6.d6168e1c.svg";